import React, {useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {IoMdArrowBack} from "react-icons/io";
import {AiOutlineDelete} from "react-icons/ai";
import {MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank,} from "react-icons/md";
import BlockCustomDialog from "./BlockCustomDialog";
import {useMutation} from "react-query";
import {addPlayListContent, getTeacherPlayList, removeTeacherPlayListInBatch} from "../../api/playlist";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";

const CheckBoxControl = ({checked, onChange}) => {
    return !checked ? (
        <MdOutlineCheckBoxOutlineBlank
            onClick={() => onChange(!checked)}
            size={20}
            color={"#000"}
            className="mr-2 cursor-pointer"
        />
    ) : (
        <MdOutlineCheckBox
            size={20}
            onClick={() => onChange(!checked)}
            color={"#000"}
            className="mr-2 cursor-pointer"
        />
    );
};

export default function BlockPlaylists() {
    const classPlanData = useSelector((state) => state.classPlan.classPlan);
    const selectedClassPlanData = useSelector((state) => state.classPlan.selectedClassPlan);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {url} = useRouteMatch();
    const splitData = url.split('/')
    const newUrl = splitData.slice(0, 4).join('/');
    const classURL = splitData.slice(0, 3).join('/');
    const [selecting, setSelecting] = useState(false);
    const [playlists, setPlaylists] = useState([]);
    const [openDeleteDialog, setDeleteDialog] = useState(false);
    const [removeList, _removeList] = useState([]);
    const [errorMsg, _errorMsg] = useState('');
    const contentId = location?.state?.contentId || null;

    //fetch the list when component render
    const fetchPlayListData = () => {
        getTeacherPlayList().then(res => {
            const data = res.data.body;
            const newPlayLists = data.map((playList) => ({
                ...playList,
                isSelected: false,
            }));
            if (newPlayLists.length > 0) {
                setPlaylists(newPlayLists);
            } else {
                setPlaylists([]);
            }
        }).catch(error => {
            console.log("Error", error)
        });
    }

    //add the isSelected key for selection the playlist
    useEffect(() => {
        fetchPlayListData();
    }, []);

    //toggle the select and unselect
    const toggleSelecting = () => setSelecting(!selecting);

    //function used to select the particular play list
    const toggleSelection = (checked, index) => {
        const newPlayLists = playlists.map((playlist, i) => {
            if (i === index) return {...playlist, isSelected: checked};
            return playlist;
        });

        setPlaylists(newPlayLists);
    };

    //url used to go to the back
    const goBack = useCallback(() => history.goBack(), []);

    const isAnySelected = playlists.some(playlist => playlist.isSelected)

    //filter the selected Playlist
    const filterSelected = () => {
        const filterList = playlists.filter((item) => item?.isSelected === true);
        if (filterList?.length > 0) {
            return filterList;
        } else {
            return [];
        }
    }

    //remove the selected playlist Batch
    const {
        mutate: removePlaylistBatch,
    } = useMutation(removeTeacherPlayListInBatch, {
        onSuccess: (data, variables) => {
            if (data.status === 200) {
                setDeleteDialog(false);
                _removeList([]);
                fetchPlayListData();
                alert("playlist Delete SuccessFully");
            }
        },
        onError: (err) => {
            console.log(err);
            _errorMsg("playlist not deleted");
            setDeleteDialog(false);
        },
    });

    //create the payload for the delete the playlist
    const deletePlaylist = () => {
        const filterList = playlists.filter((item) => item?.isSelected === true);
        const payload = filterList.map((item) => {
            return {
                id: item?.id,
            }
        });

        if (filterList?.length > 0) {
            removePlaylistBatch(payload)
        }
    }

    //open the dialogbox to get the confirmation to delete the playlist
    const openDeleteDialogBox = () => {
        setDeleteDialog(true)
        const filterList = filterSelected();
        _removeList(filterList);
    }
    // add content to the current playlist
    const {
        mutate: addContent,
    } = useMutation(addPlayListContent, {
        onSuccess: (data, variables) => {
            const classPlanId = localStorage.getItem('classPlanID'); //get the class plan ID from the localstorage
            const classID = localStorage.getItem("classId"); // get class ID From the localstorage
            alert("playlist content added SuccessFully");
            history.push(`/class/${classID}/class-plan/${classPlanId}`);
        },
        onError: (err) => {
            console.log(err);
            alert("Something Went wrong...");
        },
    });

    /** create the payload to add content to playlist*/
    const addContentToPlayList = (playListId) => {
        const start_time = moment().unix();
        const tempArr = [];
        const payload = {
            id: playListId,
            sourceId: contentId,
            createdOn: start_time,
            modifiedOn: 0
        }
        tempArr.push(payload);
        addContent({playListId: playListId, addingPayload: tempArr});
    }
    //redirect to add content page if content id is Null
    const redirectToAddContent = (playListId) => {
        if (contentId !== null) {
            addContentToPlayList(playListId)
        } else {
            history.push(`${newUrl}/select-content/${playListId}`)
        }
    }
    return (
        <>
            <div className="flex items-center justify-between">
                <div className="flex items-center">
                    <IoMdArrowBack
                        onClick={goBack}
                        size={30}
                        className="mr-3 cursor-pointer"
                    />
                    <i className="icon icon-"></i>
                    <h4 className="text-xl flex-auto">{errorMsg !== '' ?
                        <div className="flex justify-center items-center gap-2">
                            <span className="text-red-600 underline">{errorMsg}</span> <span
                            className="cursor-pointer rotate-45"
                            onClick={() => _errorMsg('')}><i
                            className="icon icon-plus-circle text-xl"></i></span></div> : 'My Playlists'}</h4>
                </div>
                <div className="flex items-center gap-x-3">
                    <button
                        onClick={toggleSelecting}
                        className="font-bold text-base font-[Poppins-Bold]"
                    >
                        {selecting ? "Cancel" : "Select"}
                    </button>
                    {
                        isAnySelected && selecting &&
                        <button
                            onClick={() => openDeleteDialogBox()}
                            className="font-bold text-lg font-[Poppins-Bold]"
                        >
                            <AiOutlineDelete size={25}/>
                        </button>
                    }
                </div>
            </div>

            <ul className="block playList list-none py-3 divide-y">
                {playlists?.map((item, index) => (
                    <li
                        key={"playlist_" + index}
                        className="flex items-center justify-between py-3"
                    >
                        <div className="flex items-center">
                            {selecting ? (
                                <CheckBoxControl
                                    checked={item.isSelected}
                                    onChange={(checked) => toggleSelection(checked, index)}
                                />
                            ) : null}
                            <p className="text-lg">{item.title}</p>
                        </div>
                        <button
                            onClick={() => redirectToAddContent(item?.id)}
                            className="underline text-base"
                        >
                            {contentId ? 'Add here' : 'Add content'}
                        </button>
                    </li>
                ))}
            </ul>
            <BlockCustomDialog
                targetId="contentWrapperBox"
                open={openDeleteDialog}
                onClose={() => setDeleteDialog(false)}
                overlayClasses="justify-center items-center backdrop-blur-md"
            >
                <div className="w-96 flex flex-col rounded-full p-4">
                    <h4 className="text-lg font-bold text-center">
                        Delete Playlist
                    </h4>
                    <div className="mt-3 mb-6">
                        <p className="text-center px-4">
                            {removeList?.length > 1 ? 'Are you sure you want to delete these playlists?' : `Are you sure you want to delete this ${removeList[0]?.title} ?`}
                        </p>
                    </div>
                    <div className="flex gap-x4">
                        <button
                            onClick={() => deletePlaylist()}
                            className="w-40 mx-auto px-10 py-2 text-black border-2 border-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            Yes
                        </button>
                        <button onClick={() => setDeleteDialog(false)}
                                className="w-40 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg">
                            No
                        </button>
                    </div>
                </div>
            </BlockCustomDialog>
        </>
    );
}


CheckBoxControl.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
}
